export function multiFilterReducer(state, action) {
  switch (action.type) {
    case "loadFilters":
      let selected = [];
      action.filters.forEach((wrapper) => {
        wrapper.filters.forEach((group) => {
          selected[group.subcategory] = [];
        });
      });

      return {
        ...state,
        filters: action.filters,
        selected: selected,
      };

    case "setCoachName":
      return {
        ...state,
        coachName: action.coachName,
      };
    case "setShowSelectedOnly":
      return {
        ...state,
        showSelectedOnly: action.status,
      };
    case "setChecked":
      let newData = {};
      newData[action.subcategory] = state.selected[action.subcategory];
      if (action.state) {
        newData[action.subcategory].push(action.value);
      } else {
        newData[action.subcategory] = newData[action.subcategory].filter(
          (n) => n != action.value
        );
      }

      return {
        ...state,
        selected: { ...state.selected, ...newData },
      };
    case "selectSubCategory":
      let newSelected = { ...state.selected };

      state.filters.forEach((wrapper) => {
        wrapper.filters.forEach((filter) => {
          filter.items.forEach((item) => {
            if (item.subcategory == action.subcategory) {
              if (!newSelected[item.subcategory].includes(item.value)) {
                newSelected[item.subcategory].push(item.value);
              }
            }
          });
        });
      });

      return {
        ...state,
        selected: { ...newSelected },
      };

    case "selectCategory":
      newSelected = { ...state.selected };

      state.filters.forEach((wrapper) => {
        wrapper.filters.forEach((filter) => {
          filter.items.forEach((item) => {
            if (item.category == action.category) {
              if (!newSelected[item.subcategory].includes(item.value)) {
                newSelected[item.subcategory].push(item.value);
              }
            }
          });
        });
      });

      return {
        ...state,
        selected: { ...newSelected },
      };

    case "deselectSubCategory":
      newSelected = { ...state.selected };
      newSelected[action.subcategory] = [];

      return {
        ...state,
        selected: { ...newSelected },
      };

    case "deselectCategory":
      newSelected = { ...state.selected };

      state.filters.forEach((wrapper) => {
        wrapper.filters.forEach((filter) => {
          if (wrapper.category == action.category) {
            newSelected[filter.subcategory] = [];
          }
        });
      });

      return {
        ...state,
        selected: { ...newSelected },
      };

    case "clearAllFilters":
      newSelected = { ...state.selected };

      state.filters.forEach((wrapper) => {
        wrapper.filters.forEach((filter) => {
          newSelected[filter.subcategory] = [];
        });
      });

      return {
        ...state,
        selected: { ...newSelected },
        coachName: "",
        showSelectedOnly: false,
      };
    default:
      throw new Error();
  }
}
